import React from 'react';
import LayoutHomeUser from '../Layouts/Admin/Layout';
import DiscoverTabs from '../Components/DiscoverTabs';

// Landing pública (accesible a cualquiera, con o sin sesión). Usa el mismo
// layout genérico que LandingWithoutHeader (Admin/Layout: sidebar de invitado
// con "Iniciar Sesión" cuando no hay sesión) para que la pastilla de
// descubrimiento se vea igual acá y en /client.
//
// El <h1> lleva la marca escrita junta: el logo del encabezado se arma como
// "YOUR" + imagen + "PACK" y los buscadores lo leían como dos palabras.
function Home() {
    return (
        <LayoutHomeUser>
            <div className="ap-screen ap-screen-inset -m-2 lg:-m-4 p-2 lg:p-4 min-h-[calc(100dvh-3.5rem)]">
                {/* El logo ya está en el encabezado: el <h1> con la marca queda solo
                    para buscadores y lectores de pantalla. */}
                <header className="text-center pt-5 pb-1 px-4">
                    <h1 className="sr-only" translate="no">YourPack</h1>
                    <p className="ap-subhead max-w-xl mx-auto">
                        Descubre modelos, sus packs de fotos y videos exclusivos y su contenido en YourPack.
                    </p>
                </header>
                <DiscoverTabs />
            </div>
        </LayoutHomeUser>
    );
}

export default Home;
